import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  withIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withIcon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#2C7A7B] hover:bg-[#236061] text-white shadow-lg hover:shadow-xl focus:ring-[#2C7A7B]',
    secondary: 'bg-[#E6FFFA] hover:bg-[#B2F5EA] text-[#234E52] focus:ring-[#E6FFFA]',
    outline: 'border-2 border-[#2C7A7B] text-[#2C7A7B] hover:bg-[#E6FFFA] focus:ring-[#2C7A7B]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} {...props} data-id="element-182">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-183" />}
    </button>;
}